/**
 * ****************************************************************************
 * @description     :   Route for bs app
 * @created at      :   2022/02/20
 * @created by      :   ANS874 – quanhvm@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const bc001000u = () => import('@/views/bc/bc001000u');
const bc003000u = () => import('@/views/bc/bc003000u');
const bc004000l = () => import('@/views/bc/bc004000l');
const bc002000l = () => import('@/views/bc/bc002000l');
const bc005000l = () => import('@/views/bc/bc005000l');
const bc006000l = () => import('@/views/bc/bc006000l');

/**
 * Defined Router
 */
export default [
    {
        path: '/bc/bc001000u',
        name: 'Bc001000u',
        component: bc001000u,
        meta: {
            title: '請求締切処理',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bc/bc003000u',
        name: 'Bc003000u',
        component: bc003000u,
        meta: {
            title: '請求締切取消',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bc/bc004000l',
        name: 'Bc004000l',
        component: bc004000l,
        meta: {
            title: '得意先別請求一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bc/bc002000l',
        name: 'Bc002000l',
        component: bc002000l,
        meta: {
            title: '得意先別請求残高一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bc/bc005000l',
        name: 'Bc005000l',
        component: bc005000l,
        meta: {
            title: '現場別請求一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bc/bc006000l',
        name: 'Bc006000l',
        component: bc006000l,
        meta: {
            title: '事業所別請求一覧',
            layout: 'MainLayout'
        }
    }
];
